import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function addNewDealerData(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'add_new_dealer/', values )
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
  }